<template>
	<system v-if="isOpen" class="system system--security">
		<ElementHeadlineBig content="Alarm" />

		<ElementText content="Security Subline" />

		<ElementInputtext name="securitycode" type="text" inputmode="verbatim" />
	</system>
</template>

<script>
/**/
import UiBase from '../ui/base.vue';
import { uiComponents } from '../../tools/viewState';
export default {
	extends: UiBase,
	data() {
		return {
			name: uiComponents.systemSecurity,
		};
	},
};
</script>
